import { Document, Font, Page } from "@react-pdf/renderer";
import font from "../fonts/ABCWhyte.ttf";
import { CVContentContext, LanguageContext } from "./CVPDF";
import FirstPageContent from "./FirstPageContent";
import Footer from "./Footer";
import Header from "./Header";
import ProfessionalCareer from "./ProfessionalCareer";
import Projects from "./Projects";
import Tech from "./Tech";

export default function Doc({ cvContent, language = 'en' }: { cvContent: any; language?: 'en' | 'de' }) {
  Font.register({
    family: "ABCWhyte",
    format: "truetype",
    fonts: [{ src: font }, { src: font, fontWeight: "bold" }],
  });

  return (
    <LanguageContext.Provider value={language}>
      <CVContentContext.Provider value={cvContent}>
        <Document>
          <Page
            style={{
              paddingBottom: "91px",
            }}
          >
            <Header />
            <FirstPageContent />
            <Tech />
            <ProfessionalCareer />
            <Projects />
            <Footer />
          </Page>
        </Document>
      </CVContentContext.Provider>
    </LanguageContext.Provider>
  );
}
